<template>
  <div>
    <div
      v-if="account !== null"
      class="wide-container">
      <PageTitle
        :props="{company: account.company}"
        title="dashboard.welcome"/>

      <p>
        <Translated msg="dashboard.welcome-text"/>
      </p>

      <LoyaltyPage v-if="loyaltyParticipant"/>

      <template v-if="statusPage">
        <PageTitle
          icon="signal"
          title="system-status.title"/>
        <p>{{ $t('system-status.text') }}</p>

        <div class="d-flex justify-content-end">
          <a
            class="btn btn-primary"
            :href="statusPage"
            rel="noopener noreferrer"
            target="_blank">
            <SimpleIcon icon="external-link-alt"/>
            {{ $t('system-status.open') }}
          </a>
        </div>
      </template>
    </div>
    <div
      v-else
      class="small-container">
      <DataCard
        class="mb-2"
        header-class="bg-theme"
        title="auth.login"
        title-icon="key">
        <p>
          <Translated msg="auth.login-text"/>&nbsp;<Translated
            msg="auth.login-text-sso"
            :props="{company}"/>
        </p>

        <div class="d-flex justify-content-end">
          <LoadButton
            icon="sign-in-alt"
            label="auth.login-sso"
            :label-props="{company}"
            :loading="authState.loggingIn"
            type="button"
            @click="onSsoAuth"/>
        </div>
      </DataCard>

      <DataCard
        class="mb-2"
        header-class="bg-theme"
        title="apply.title.short"
        title-icon="signature">
        <p>
          <Translated msg="apply.text.partner"/>
        </p>

        <div class="d-flex justify-content-end">
          <router-link
            class="btn btn-primary"
            :to="{name: 'apply'}">
            <SimpleIcon icon="hand-point-right"/>
            <Translated msg="apply.button.partner"/>
          </router-link>
        </div>
      </DataCard>

      <DataCard
        v-if="statusPage"
        class="mb-2"
        header-class="bg-theme"
        title="system-status.title"
        title-icon="signal">
        <p>{{ $t('system-status.text') }}</p>

        <div class="d-flex justify-content-end">
          <a
            class="btn btn-primary"
            :href="statusPage"
            rel="noopener noreferrer"
            target="_blank">
            <SimpleIcon icon="external-link-alt"/>
            {{ $t('system-status.open') }}
          </a>
        </div>
      </DataCard>
    </div>
  </div>
</template>

<script lang="ts">
import LoyaltyPage from '@/pages/account/LoyaltyPage.vue';
import {companyName} from '@/utils';
import LoadButton from '@components/form/LoadButton.vue';
import DataCard from '@components/layout/DataCard.vue';
import PageTitle from '@components/layout/PageTitle.vue';
import SimpleIcon from '@components/SimpleIcon.vue';
import {useApiErrors} from '@plugins/api/api';
import {useAuthenticator, useCurrentAccount} from '@plugins/auth/auth';
import {useConfiguration} from '@plugins/config/config';
import Translated from '@plugins/i18n/components/Translated.vue';
import {defineComponent, reactive} from 'vue';

export default defineComponent({
  name: 'HomePage',
  components: {
    DataCard,
    LoyaltyPage,
    LoadButton,
    SimpleIcon,
    Translated,
    PageTitle,
  },
  setup() {
    const config = useConfiguration();
    const authenticator = useAuthenticator();
    const account = useCurrentAccount();
    const authApiErrors = useApiErrors();

    const authState = reactive({
      loggingIn: false,
      authFailure: false,
    });

    return {
      account,
      authApiErrors,
      authState,
      onSsoAuth: async () => {
        authState.loggingIn = true;
        try {
          window.location.href = await authenticator.generateSsoAuthenticationRedirect();
        } catch {
          authState.authFailure = true;
          authState.loggingIn = false;
        }
      },
      loyaltyParticipant: authenticator.isLoyaltyParticipant,
      company: companyName(),
      statusPage: config.getStatusPage(),
    };
  },
});
</script>
